import { STORAGE_ACCOUNT } from '../../../../Constants';
import React, { useState, useEffect, useRef } from "react";
import "./c.css";
import "./contact.css";
import Contact from "../../../Contactus";
import { getInitials } from "../../../../Utility";
import styles from "./ProfileContact.module.css";
import { Urls } from "../../../../Urls";
import axios from "axios";

const ContactV = ({ transporter_data }) => {
  const scrollContainerRef = useRef(null);
  const [contacts, setContacts] = useState([]);
  const [logoUrls, setLogoUrls] = useState({});
  const [showScrollButtons, setShowScrollButtons] = useState(false);

  useEffect(() => {
    if (transporter_data.contact_information) {
      setContacts(transporter_data.contact_information);
    } else {
      setContacts([]);
    }
  }, [transporter_data]);

  useEffect(() => {
    const checkScroll = () => {
      if (scrollContainerRef.current) {
        const { scrollWidth, clientWidth } = scrollContainerRef.current;
        setShowScrollButtons(scrollWidth > clientWidth);
      }
    };

    checkScroll();

    window.addEventListener("resize", checkScroll);
    return () => {
      window.removeEventListener("resize", checkScroll);
    };
  }, [contacts]);

  // Fetch logo URLs whenever contacts change
  useEffect(() => {
    const fetchLogoUrls = async () => {
      const urls = {};

      const logoContacts = contacts.filter((c) => c.logo);
      await Promise.all(
        logoContacts.map(async (contact) => {
          try {
            const body = {
              action: "download",
              accountName: STORAGE_ACCOUNT,
              containerName: "public-container",
              fileName: contact.logo,
            };
            const response = await axios.post(Urls.fileService, body);
            urls[contact.logo] = response.data.url;
          } catch (error) {
            console.error("Error fetching logo for", contact.name, error);
            urls[contact.logo] = null;
          }
        })
      );

      setLogoUrls(urls);
    };

    if (contacts.length > 0) {
      fetchLogoUrls();
    }
  }, [contacts]);

  const scroll = (scrollOffset) => {
    if (scrollContainerRef.current) {
      scrollContainerRef.current.scrollBy({
        left: scrollOffset,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="container contact_Details_Body">
      {contacts.length > 0 ? (
        <div className="position-relative">
          {showScrollButtons && (
            <button
              className={`${styles.scrollBtn} ${styles.scrollBtnLeft}`}
              onClick={() => scroll(-300)}
            >
              <i className="fa fa-chevron-left p-2" aria-hidden="true" />
            </button>
          )}

          <div
            className={`${styles.contactsScrollContainer}`}
            ref={scrollContainerRef}
          >
            {contacts.map((contact) => (
              <div className={`${styles.contactCardBody}`} key={contact.name}>
                <div className={`${styles.contactImageWrapper}`}>
                  {contact.logo && logoUrls[contact.logo] ? (
                    <img alt="" src={logoUrls[contact.logo]} />
                  ) : (
                    <span>{getInitials(contact.name)}</span>
                  )}
                </div>
                <div>
                  <div className={`${styles.contactName}`}>
                    <b>{contact.name}</b>
                  </div>
                  <div className={`${styles.contactDesignation}`}>
                    {contact.designation}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {showScrollButtons && (
            <button
              className={`${styles.scrollBtn} ${styles.scrollBtnRight}`}
              onClick={() => scroll(300)}
            >
              <i className="fa fa-chevron-right p-2" aria-hidden="true" />
            </button>
          )}
        </div>
      ) : (
        <>
          <h4 className="data_header">Contact Information</h4>
          <span>Details not available</span>
        </>
      )}

      <br />

      {/* Modal */}
      <div
        className="modal fade"
        id="contact_us_modal_transporter"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="contact_us_modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title s-modal-title" id="exampleModalLabel">
                Enquiry for Logistics Requirement
              </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Contact display_for="transporter_client_enquiry" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactV;
